export default __webpack_public_path__ + "static/media/Access.951aa72a.png";